import {ShopBankPanel} from "@/scenes.ui/shop-bank-panel";
import {BankOption, ItemType} from "@/store/shop/types";
import {Player, UserSource} from "@/store/player/types";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import PackUtils from "@/utils/pack-utils";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class PackBankPanel extends ShopBankPanel {

    public static HEIGHT = 174;

    constructor(scene: Phaser.Scene, x: number, y: number, bo: BankOption, player: Player, userSource: UserSource, callback: () => void) {
        super(scene, x, y, bo, player, userSource, callback);

        let healthValue = '';
        for (let it of bo.items) {
            if (it.itemType === ItemType.HEALTH) {
                healthValue = String(it.count) + '%';
            }
        }

        let healthText = TextUtils.addTextAdvanced(scene, '+' + healthValue, 125, this.getGemsCountLinePosY() + 50,
            '#dddcdc', 16, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);

        let countIcon = SpriteUtils.addSprite(this.scene!, healthText.getRightCenter().x! / CU.S + 20, this.getGemsCountLinePosY() + 50 - 1,
            Keys.ATLAS_PROFILE, Keys.IMG_HEART_ICON)
            .setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(countIcon, 34 * CU.S, 30 * CU.S);

        let healthText2 = TextUtils.addTextAdvanced(scene, Tr('all.h'), countIcon.getRightCenter().x! / CU.S + 5,
            this.getGemsCountLinePosY() + 50,
            '#DDDCDC', 16, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);

        this.add([healthText, countIcon, healthText2]);

        let discValue = PackUtils.getMythDiscount(bo.gems + bo.bonus);

        if (discValue > 0) {
            let discText = TextUtils.addTextAdvanced(scene, Tr('disc.pl') + String(discValue) + Tr('ev.myth'),
                125, this.getGemsCountLinePosY() + 78,
                '#ffc93a', 12, 'normal', 470, 'left', 1, Fonts.GOTHIC_DEUTSCH);
            this.add(discText);
        }
    }

    protected getBackKey(decorationId: string) {
        return Keys.PACK_PANEL_BACK;
    }

    protected getHeight(decorationId: string) {
        return PackBankPanel.HEIGHT;
    }

    protected getGemsCountLinePosY() {
        return 75;
    }

    protected getOfferLinePosY() {
        return 20;
    }
}
